// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FullWidth_wrapper__CbvEh"};